import { Injectable } from '@angular/core';
import { HttpGeneralService, StockParms, StockParmsSpesial } from '../../shared/shared';
import { ExaminationSupply } from './examination-supply';
import { CONFIG } from '../../shared/config';
let ExaminationSupplyUrl = CONFIG.baseUrls.ExaminationSupply;
let stockTransUrl = CONFIG.baseUrls.StockTrans;

@Injectable()
export class ExaminationSupplyService {
    constructor(private httpGeneralService: HttpGeneralService) { }


    addStrExaminationSupply(ExaminationSupply: ExaminationSupply) {
        return this.httpGeneralService.add(ExaminationSupply, ExaminationSupplyUrl)
    }


    getExaminationSupply(_StockParms: StockParmsSpesial[]) {
        return this.httpGeneralService.add(_StockParms, `${ExaminationSupplyUrl}/getExaminationList`);
        ////data[0]
    }



    getPoOrderSupply(_StockParms: StockParms, notes: string) {
        // if(notes == 'Assets')
        // {
        //     return this.httpGeneralService.add<StockParms>(_StockParms, `${ExaminationSupplyUrl}/AssetsPoOrderSupplyLoad`);
        // }
        // else

        return this.httpGeneralService.add<StockParms>(_StockParms, `${ExaminationSupplyUrl}/getPoOrderSupplyList`);

    }
    itemsLoad(_StockParms: StockParms[]) {
        return this.httpGeneralService.addCollection<StockParms>(_StockParms, `${stockTransUrl}/itemsLoad`);
        //data[0]
    }
    deleteStrExaminationSupply(ExaminationSupply) {
        return this.httpGeneralService.delete(ExaminationSupply.serial, ExaminationSupplyUrl)
    }

    getItems(itemCodes: string) {
        return this.httpGeneralService.getWith(`${stockTransUrl}/${itemCodes}`)
    }
    updateExaminationUserSignature(ExaminationSupply: ExaminationSupply) {
        return this.httpGeneralService.add(ExaminationSupply, `${ExaminationSupplyUrl}/UpdateExaminationUserSignature`)
    }

}
